import { IntegrationType } from '../../../server/mpsklad_core/Entity/IntegrationType'
import ozonLogo from '../../../assets/marketplaceIcons/ozon.png'
import wbLogo from '../../../assets/marketplaceIcons/wb.png'
import ymLogo from '../../../assets/marketplaceIcons/ym.png'
import moySkladIcon from '../../../assets/marketplaceIcons/moysklad.png'

export const accountsLogoSwitcher = (t: IntegrationType) => {
  switch (t) {
    case IntegrationType.Ozon:
      return ozonLogo
    case IntegrationType.Wildberries:
      return wbLogo
    case IntegrationType.YandexMarket:
      return ymLogo
    case IntegrationType.MoySklad:
      return moySkladIcon
  }
}